import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const StudentEngagementTable = (props) => (
  <KpiTable
    title="Engagement"
    description="The number represents the average time that students have studied in the reference month. It only considers students who have studying time."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={true}
    onSelect={props.onSelect}
    formatter={props.formatter}
    feedbackColorRender={props.feedbackColorRender}
    additionalColumns={[
      {
        label: 'Standard Deviation',
        path: 'currentStandardDeviation',
        render: (value) => props.formatter(value / 3600),
      },
      {
        label: 'Total of Registers',
        path: 'currentAmount',
      },
    ]}
  />
);

StudentEngagementTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func,
};

export default StudentEngagementTable;
